import { render, staticRenderFns } from "./settingAfra.vue?vue&type=template&id=6fba8e7a&scoped=true&"
import script from "./settingAfra.vue?vue&type=script&lang=js&"
export * from "./settingAfra.vue?vue&type=script&lang=js&"
import style0 from "./settingAfra.vue?vue&type=style&index=0&id=6fba8e7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fba8e7a",
  null
  
)

export default component.exports